import { FeatureFlagBanks, FeatureFlagPlatform } from '@gruposantander/mb-ui-framework';

const TRANSLATIONS_BASE_VERSION = '1.0.0';
const TRANSLATIONS_BASE_LANGUAGE_SPAIN = 'es-ES';

export const FEATURE_FLAG_CONFIG = {
  Spain: {
    bank: FeatureFlagBanks.BANK_ES,
    featureFlagServiceHost: window.MIDDLEWARE_BASE_HOST + '/mb-api-feature-flag',
    platform: FeatureFlagPlatform.WEB,
  },
};

export const TRANSLATIONS_CONFIG = {
  Spain: {
    baseVersion: {
      language: TRANSLATIONS_BASE_LANGUAGE_SPAIN,
      version: TRANSLATIONS_BASE_VERSION,
    },
    platform: FeatureFlagPlatform.WEB,
    translationsServiceHost: window.MIDDLEWARE_BASE_HOST + '/mb-api-translations',
  },
};